import React from "react";

export default function HealthCheck() {
  return <div>
    <p>status: healthy</p>
  </div>;
}
